var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bind-channel" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "同步操作",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c("el-alert", {
            attrs: {
              title:
                "同步品牌，无需选择城市与品牌；同步门店与商品需要选择门店与品牌信息。",
              type: "warning",
              "how-icon": "",
            },
          }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "pram",
              attrs: { "label-width": "130px", model: _vm.ruleForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "同步内容：", prop: "type" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.ruleForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "type", $$v)
                        },
                        expression: "ruleForm.type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v("同步蛋糕商品"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("同步所有品牌"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("同步门店"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "同步品牌：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        clearable: "",
                        placeholder: "请选择",
                        filterable: "",
                        "filter-method": _vm.handleAgreementSearch,
                      },
                      model: {
                        value: _vm.ruleForm.brandId,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "brandId", $$v)
                        },
                        expression: "ruleForm.brandId",
                      },
                    },
                    _vm._l(_vm.brandOption, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.brandStr, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "同步城市：", prop: "areaList" } },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      clearable: "",
                      options: _vm.addresData,
                      props: {
                        value: "id",
                        label: "name",
                        children: "child",
                        checkStrictly: true,
                      },
                    },
                    model: {
                      value: _vm.ruleForm.areaList,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "areaList", $$v)
                      },
                      expression: "ruleForm.areaList",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handerSubmit },
                },
                [_vm._v("确定")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }